module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M09-clean-7b83065bfaf3485ba860d9c8c2a1a333.png";